import { yupResolver } from '@hookform/resolvers/yup';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';

import { GrantsModule } from './types';

import { MODULES } from 'RestAPIs/endpoints';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import ModuleDataSection from './ModuleDataSection';
import { grantsModulesSchema } from './schema';

const EditGrantsModuleForm = ({
  rowData,
  handleClose
}: FormComponentProps<GrantsModule>) => {
  const methods = useForm({
    resolver: yupResolver(grantsModulesSchema),
    defaultValues: grantsModulesSchema.cast(rowData)
  });
  const { mutateAsync, isLoading } = useUpdateResource({
    url: MODULES,
    id: rowData?.grantCatalogId ?? '',
    invalidateQueryKey: ['modules', 'list']
  });

  const submitForm = async (data) => {
    await mutateAsync(data).then(handleClose);
  };

  return (
    <MultiStepForm
      methods={methods}
      onSubmit={methods.handleSubmit(submitForm)}
    >
      <ModuleDataSection />
      <MultiStepForm.Actions>
        <Box display="flex" ml="auto">
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            autoFocus
            color="primary"
          >
            {t('save')}
          </LoadingButton>
        </Box>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};

export default EditGrantsModuleForm;
